// extracted by mini-css-extract-plugin
export default {"Modal":"styles_Modal__yyEz4","Modal--isOpen":"styles_Modal--isOpen__9yYqe","Modal-inner":"styles_Modal-inner__HPIbM"};